<template>
  <div>
    <template v-if="is_detail_page">
      <v-btn
        v-if="!check_in_cart(product)"
        depressed
        color="accent darken-4"
        @click="add"
        :disabled="disabled"
      >
        <slot name="add-cart-text">
          <div
            v-if="!in_not_desktop"
            :class="$style.btn"
          >
            <v-icon>mdi-cart-outline</v-icon>
            В корзину
          </div>
          <div v-else>
            <v-icon small>mdi-cart-outline</v-icon>
          </div>
        </slot>
      </v-btn>
      <template v-else>
        <v-btn
          depressed
          color="accent darken-4"
          :to="go_to_cart"
          :disabled="disabled"
        >
          <slot name="in-cart-text">
            <div :class="$style.btn">
              <v-icon>mdi-cart-arrow-right</v-icon>
              Перейти <br> в корзину
            </div>
          </slot>
        </v-btn>
      </template>
    </template>
    <template v-else>
      <v-btn
        v-if="!check_in_cart(product)"
        icon
        color="accent darken-4"
        @click="add"
        :disabled="disabled"
      >
        <slot name="add-cart-text">
          <div v-if="!in_not_desktop">
            <v-icon>mdi-cart-outline</v-icon>
          </div>
          <div v-else>
            <v-icon small>mdi-cart-outline</v-icon>
          </div>
        </slot>
      </v-btn>
      <template v-else>
        <v-btn
          icon
          color="accent darken-4"
          :to="go_to_cart"
          :disabled="disabled"
        >
          <slot name="in-cart-text">
            <v-icon>mdi-cart-arrow-right</v-icon>
          </slot>
        </v-btn>
      </template>
    </template>
  </div>
</template>

<script lang="ts">
import {
  Component,
  Emit,
  Prop,
  Vue,
} from 'vue-property-decorator';
import { ProductShared } from '@/modules/products/shared/types';
import { check_item_in_cart } from '@/modules/cart/shared/services';
import { SharedCartPages } from '@/modules/cart/shared/types';
import { global_store } from '@/store';
import { Products } from '@/modules/products/types';

@Component
export default class CartBtn extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  product!: ProductShared;

  @Prop({
    type: [
      Function,
      Boolean,
    ],
    default: false,
  })

  @Prop({ type: Boolean, default: false })
  disabled?: boolean;

  @Emit()
  add() {
    return true;
  }

  get go_to_cart() {
    return { name: SharedCartPages.CART };
  }

  get in_not_desktop() {
    return global_store.state.isTablet || global_store.state.isMobile;
  }

  get is_detail_page() {
    return this.$route.name === Products.Pages.PRODUCT_DETAIL;
  }

  check_in_cart = check_item_in_cart;
}
</script>

<style module lang="scss">
  .btn {
    display: flex;
    align-items: center;
    column-gap: 8px;
  }
</style>
